class EventBus {
  constructor() {
    this.listeners = new Map();
  }

  $on(event, handler) {
    if (!this.listeners.has(event)) {
      this.listeners.set(event, new Set());
    }
    this.listeners.get(event).add(handler);

    return this;
  }

  $once(event, handler) {
    const wrapped = (...args) => {
      this.$off(event, wrapped);
      handler(...args);
    };
    wrapped.fn = handler;

    return this.$on(event, wrapped);
  }

  $off(event, handler) {
    if (!event) {
      this.listeners.clear();

      return this;
    }

    const set = this.listeners.get(event);
    if (!set) {
      return this;
    }

    if (!handler) {
      this.listeners.delete(event);

      return this;
    }

    for (const h of set) {
      if (h === handler || h.fn === handler) {
        set.delete(h);
      }
    }

    return this;
  }

  $emit(event, ...args) {
    const set = this.listeners.get(event);
    if (set) {
      for (const handler of [ ...set ]) {
        handler(...args);
      }
    }

    return this;
  }
}

const eventBus = new EventBus();

export default eventBus;
